<script setup lang="ts">
const store = useStore()
const { mainMenu } = storeToRefs(store)
interface Link {
  extensions: {
    categoryUrlData: {
      linkType: string
      urlPrefix: string
      url: string
    }
  },
  externalLink: string
}
const getLink = ({ extensions: { categoryUrlData: { linkType, urlPrefix, url } }, externalLink }: Link) => linkType === 'external' ? externalLink : `/${urlPrefix}/${url}`
const getTargetLink = (target: boolean) => target ? '_blank' : null
const getMenuGrid = (children) => !children.find(el => el.children.length) && children.length > 10 ? 'menu-grid' : null
</script>

<template>
  <ul class="menu flex justify-between gap-[30px] relative z-10 [&_ul]:after:content-[''] [&_ul]:after:absolute [&_ul]:after:inset-0 [&_ul]:after:shadow-[0px_8px_24px_rgba(66,68,90,1)] [&_ul]:after:pointer-events-none [&_ul]:after:-z-1">
    <li v-for="link_1 in mainMenu" :key="link_1.id">
      <NuxtLink :to="getLink(link_1)" :target="getTargetLink(link_1.extensions.categoryUrlData.linkNewTab)" class="text-menu hover:text-menu-hover">
        <span class="text-14 font-bold uppercase">{{ tor(link_1.name) }}</span>
      </NuxtLink>
      <ul v-if="link_1.children.length" :class="getMenuGrid(link_1.children)" class="hidden absolute bg-white w-56 pt-[10px]">
        <li v-for="link_2 in link_1.children" :key="link_2.id" class="group/link_1 relative px-[15px]">
          <NuxtLink :to="getLink(link_2)" :target="getTargetLink(link_2.extensions.categoryUrlData.linkNewTab)" class="flex justify-between items-center text-12 text-menu hover:text-menu-hover border-b border-solid border-gray-400 group-last/link_1:border-0 p-[10px]">
            <span>{{ tor(link_2.name) }}</span>
            <i v-if="link_2.children.length" class="icon-arrow-menu" />
          </NuxtLink>
          <ul v-if="link_2.children.length" class="hidden absolute bg-white w-56 top-0 left-56 min-h-full">
            <li v-for="link_3 in link_2.children" :key="link_3.id" class="group/link_2 relative px-[15px]">
              <NuxtLink :to="getLink(link_3)" :target="getTargetLink(link_3.extensions.categoryUrlData.linkNewTab)" class="flex justify-between items-center text-12 text-menu hover:text-menu-hover border-b border-solid border-gray-400 group-last/link_2:border-0 p-[10px]">
                <span>{{ tor(link_3.name) }}</span>
                <i v-if="link_3.children.length" class="icon-arrow-menu" />
              </NuxtLink>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.menu {
  > li {
    &:hover {
      > ul {
        @apply block;
        &.menu-grid {
          @apply grid grid-rows-10 grid-flow-col w-auto;
          > li {
            @apply min-w-[250px];
            &:nth-child(10n) {
              a {
                @apply border-0;
              }
            }
          }
        }
        > li {
          &:hover {
            > ul {
              @apply block;
              > li {
                &:hover {
                  > ul {
                    @apply block;
                  }
                  > a {
                    > i {
                      @apply rotate-180;
                    }
                  }
                }
              }
            }
            > a {
              > i {
                @apply rotate-180;
              }
            }
          }
          a {
            &:hover {
              @apply bg-gray-500 text-white font-bold;
            }
          }
        }
      }
    }
  }
}
</style>
